export const GET_GLOBAL_VARIABLES_REQUEST = 'global/get_global_variables_request';
export const GET_GLOBAL_VARIABLES_SUCCESS = 'global/get_global_variables_success';
export const GET_GLOBAL_VARIABLES_FAILED = 'global/get_global_variables_falied';

export const SET_ITEM = 'global/set_item';
export const REMOVE_ITEM = 'global/remove_item';
export const CLEAR_DATA = 'global/clear_data';

export type GlobalAction = typeof SET_ITEM | typeof REMOVE_ITEM | typeof CLEAR_DATA;
